// Axis helpers shared by the process page's duration charts.
import { formatDuration } from "../../utils";

/** Round durations, in seconds, for the process page's chart axes to tick at. */
export const NICE_STEPS = [
  1, 2, 5, 10, 15, 30, 60, 120, 300, 600, 900, 1800, 3600, 7200, 10800, 21600, 43200, 86400,
];

// Narrow domains need seconds even past ten minutes, or adjacent ticks can have identical labels.
// The default retains the shared duration formatting used by the trend chart.
export const formatAxisDuration = (seconds: number, resolution = 60) => {
  if (resolution < 1) {
    const precision = Math.min(6, Math.ceil(-Math.log10(resolution)));
    const rounded = Number(seconds.toFixed(precision));
    const minutes = Math.floor(rounded / 60) * 60;
    const remainder = Number((rounded - minutes).toFixed(precision));
    return minutes > 0
      ? `${formatDuration(minutes)}${remainder ? ` ${remainder}s` : ""}`
      : `${rounded}s`;
  }
  if (seconds > 0 && seconds < 1) return `${seconds.toFixed(1)}s`;
  const rounded = Math.round(seconds);
  const remainder = rounded % 60;
  if (resolution < 60 && rounded >= 600 && remainder > 0)
    return `${formatDuration(rounded - remainder)} ${remainder}s`;
  return formatDuration(seconds);
};

export const clamp = (value: number, min: number, max: number) =>
  Math.min(max, Math.max(min, value));
